<template>
  <div>
    <div class="header-card">
      <div class="close-btn">
        <img src="@/assets/close.png" height="18" width="18" alt="close-icon" @click="back">
      </div>
      <div class="header-card-text">
        <h3>Angel Investments Transactions</h3>
      <!--<p class="sub-text fnt-14">Use the options below to fund your Smart Stewards wallet</p>-->
      </div>
    </div>
    <div class="content">
      <div v-if="pageLoading" class="text-center mt-5">
        <vue-loaders-ball-pulse color="red" scale=".75"></vue-loaders-ball-pulse>
        <p class="loadingText">Please wait</p>
      </div>
      <div v-else>
        <div v-if="!check">
          <div class="notification">
            <img src="@/assets/investment.svg" height="120" width="120" class="mb-4" alt="icon">
            <p>Pay ₦20,000 annual subscription fee for Angel Investing</p>
            <button class="btn primary-btn btn-block open-sans"
            @click="joinAngelInv"><span v-if="!loading">Pay</span>
            <vue-loaders-ball-spin-fade-loader scale=".5" v-else>
            </vue-loaders-ball-spin-fade-loader></button>
          </div>
        </div>
        <div v-else>
          <div class="notification mt-4">
            <p>You are subscribed for Angel Investing!</p>
            <p>Kindly visit this link to join the whatapp group <a href=" https://chat.whatsapp.com/GzzXRMtOvIkCScK7lWNVs6" target="_blank" class="fnt-14">https://chat.whatsapp.com/GzzXRMtOvIkCScK7lWNVs6</a></p>
          </div>
          <!-- <form>
            <div class="form-group">
              <label class="open-sans bold">Make Cooperative Payment</label>
              <input type="number" v-model="amount" placeholder="Amount" class="form-control"
              required>
            </div>
            <button class="btn primary-btn btn-block open-sans" :disabled="isDisabled"
            @click="addCooperative"><span v-if="!loading">Pay</span>
            <vue-loaders-ball-spin-fade-loader scale=".5" v-else>
            </vue-loaders-ball-spin-fade-loader></button>
          </form>
          <div class="transactions" v-if="transactions.length > 0">
            <h4>Transactions</h4>
            <div class="trans-table">
            <div class="trans-table-row" v-for="(trans, ind) in transactions.slice().reverse()"
            :key="ind">
            <div class="row2">
                <p>₦{{ Number(trans.amount).toLocaleString() }}</p>
              </div>
              <div class="row1">
                <p class="p1">{{ trans.createdAt | formatDate}}</p>
              </div>
            </div>
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <success-component v-if="showSuccess" :message="successMsg" @close="closePrompt">
    </success-component>
    <error-component v-if="showError" :message="errorMsg" @close="closePrompt"></error-component>
    <angelinvestment-pop v-if="showInvPop" @close="closePrompt"></angelinvestment-pop>
  </div>
</template>

<script>
import ErrorComponent from '../components/Error.vue';
import SuccessComponent from '../components/Success.vue';
import AngelinvestmentPop from '../components/AngelinvestmentPop.vue';
import { withWalletTypeData, withWalletTypeParams } from '../utils/walletType';

export default {
  components: {
    ErrorComponent,
    SuccessComponent,
    AngelinvestmentPop,
  },
  computed: {
    isDisabled() {
      if (!this.amount) {
        return true;
      }
      return false;
    },
  },
  created() {
    this.checkPop();
    this.checkSubscription();
  },
  data() {
    return {
      status: '',
      amount: '',
      loading: false,
      pageLoading: false,
      showSuccess: false,
      showError: false,
      showInvPop: false,
      check: false,
    };
  },
  methods: {
    checkPop() {
      const investmentPopup = localStorage.getItem('angelinvestment-popup');
      if (!investmentPopup) {
        this.showInvPop = true;
      }
    },
    async joinAngelInv() {
      this.loading = true;
      try {
        const url = `${this.$baseUrl}/angel-inv/join`;
        const data = withWalletTypeData(this.$store);
        await this.$http({ url, data, method: 'POST' });
        this.checkSubscription();
        this.successMsg = 'You have Successfully subscribed to the Angel investment';
        this.showSuccess = true;
        this.loading = false;
      } catch (error) {
        console.log(error);
        this.errorMsg = error.response.data.message;
        this.showError = true;
        this.loading = false;
        setTimeout(() => {
          this.showError = false;
        }, 3000);
      }
    },
    async checkSubscription() {
      this.pageLoading = true;
      const params = withWalletTypeParams(this.$store);
      const url = `${this.$baseUrl}/angel-inv/check`;
      const res = await this.$http({ url, method: 'GET', params });
      this.check = res.data.check;
      this.pageLoading = false;
    },
    back() {
      this.$router.go(-1);
    },
    closePrompt() {
      this.showError = false;
      this.showSuccess = false;
      this.showInvPop = false;
    },
  },
};
</script>

<style lang="scss" scoped>
 a{
    color: #EE0E4C;
    font-weight: 400;
  }
  p {
    margin-bottom: .25rem;
  }
  .trans-table{
    padding: 1rem;
    border-radius: 8px;
    background-color: #FFF;
    &-row{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: .75rem 0;
      border-bottom: 1px solid #E5E5E5;
      &:last-child{
        border-bottom: none;
      }
    }
    .row1{
      .p1{
        font-size: 11px;
        line-height: 12px;
        color: #49566A;
        font-family: 'Cabin', sans-serif;
      }
    }
    .row2{
      p{
        font-family: 'Cabin', sans-serif;
        font-weight: 600;
        font-size: 16px;
      }
    }
  }
  .transactions{
    margin-top: 1rem;
  }
  form{
    margin-bottom: 2rem;
  }
  .notification{
    text-align: center;
    font-family: 'Cabin', sans-serif;
    font-weight: 600;
    font-size: 16px;
    // margin-top: 2rem;
    p{
      margin-bottom: 1rem;
    }
  }
  .loadingText{
    font-size: 20px;
  }
</style>
